"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var conversationService_1 = require("../../Services/conversationService");
var service_service_1 = require("../../Services/service.service");
var confirmation_sheet_component_1 = require("../../Messages/confirm-sheet/confirmation-sheet.component");
var ngx_gallery_1 = require("ngx-gallery");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var environment_1 = require("src/environments/environment");
var ConversationsListComponent = /** @class */ (function () {
    function ConversationsListComponent(mainService, conversationService, router, route) {
        var _this = this;
        this.mainService = mainService;
        this.router = router;
        this.route = route;
        this.perPage = 24; //count convs per page 0 is for all
        this.page = 0;
        this.loading = false;
        this.noConversationsInfo = false;
        this.refreshingLastList = false;
        this._currentUserIsAdmin = false;
        this.conversations = [];
        this.images = {};
        this.galleryOptions = [
            {
                thumbnailsColumns: 6,
                width: "400px",
                imageSize: 'Contain',
                imageAnimation: ngx_gallery_1.NgxGalleryAnimation.Slide,
                thumbnailsAutoHide: true
            },
            // max-width 800
            {
                breakpoint: 1200,
                thumbnailsColumns: 5,
            },
        ];
        this._allConversationsCount = 0;
        this._selectedConvCount = 0;
        this.convListArray = [];
        this.checboxListArray = [];
        this.selectAllCheckbox = false;
        this.activeConversationId = this.route.snapshot.paramMap.get('id');
        this.route.queryParams.subscribe(function (params) {
            var paramPage = (isNaN(params['page']) ? 1 : params['page']);
            paramPage = paramPage <= 0 ? 1 : paramPage;
            _this.page = Number(paramPage) - 1;
            var paramPerPage = (isNaN(params['perPage']) ? 24 : params['perPage']);
            if (paramPerPage)
                _this.perPage = Number(paramPerPage);
            else
                _this.perPage = 24;
        });
        //if(this.activeConversationId) this.perPage = 0;
        this._mainService = mainService;
        this._conversationService = conversationService;
    }
    ConversationsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userNick = this._mainService.userService.getUserId();
        this._currentUserIsAdmin = this._mainService.userService.isAdmin();
        var lastConversations = this._conversationService.getLastConversations();
        if (lastConversations && !this.activeConversationId) {
            this.refreshingLastList = true;
            this.conversations = lastConversations;
            this.reloadConversations(false);
        }
        else {
            this.reloadConversations();
        }
        this._conversationService.getConversationsCount().then(function (result) {
            _this._allConversationsCount = result;
        });
    };
    ConversationsListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.convListArray = this.convList.toArray();
        this.convList.changes.subscribe(function (t) {
            _this.ngForRendred();
        });
        this.checboxList.changes.subscribe(function (t) {
            _this.ngForRendredChecboxes();
        });
    };
    ConversationsListComponent.prototype.ngForRendred = function () {
        this.convListArray = this.convList.toArray();
    };
    ConversationsListComponent.prototype.ngForRendredChecboxes = function () {
        this.checboxListArray = this.checboxList.toArray();
    };
    Object.defineProperty(ConversationsListComponent.prototype, "pageEvent", {
        get: function () {
            return this._pageEvent;
        },
        set: function (value) {
            this._pageEvent = value;
            this.page = value.pageIndex;
            this.addUrlPageParam(value.pageIndex + 1);
            this.reloadConversations();
        },
        enumerable: true,
        configurable: true
    });
    ConversationsListComponent.prototype.pageChange = function (e) {
        window.scroll(0, 0);
    };
    ConversationsListComponent.prototype.addUrlPageParam = function (value) {
        var queryParams = { page: value };
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: 'merge',
        });
    };
    Object.defineProperty(ConversationsListComponent.prototype, "allConversationsCount", {
        get: function () {
            return this._allConversationsCount;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsListComponent.prototype.reloadConversations = function (loading) {
        var _this = this;
        if (loading === void 0) { loading = true; }
        this.loading = loading;
        this._conversationService.getConversations(this.perPage, this.page).then(function (result) {
            _this.loading = false;
            _this.noConversationsInfo = (result.conversations == null || result.conversations.length == 0);
            _this.conversations = result.conversations;
            _this.conversations.forEach(function (conversation) {
                conversation.messages.forEach(function (message) {
                    if (message.images.length > 0) {
                        if (_this.images[conversation.conversationId] == null) {
                            _this.images[conversation.conversationId] = {};
                        }
                        _this.images[conversation.conversationId][message.conversationMessageId] = _this.prepareImages(message);
                    }
                });
            });
            _this.refreshingLastList = false;
        }).catch(function (error) {
            _this.loading = false;
            _this._mainService.showError(error);
        });
    };
    ConversationsListComponent.prototype.hasImages = function (conversationIndex, messageIndex) {
        return this.images[conversationIndex] != null && this.images[conversationIndex][messageIndex] != null && this.images[conversationIndex][messageIndex].length > 0;
    };
    ConversationsListComponent.prototype.clearTitle = function (title) {
        var regex = /\[[A-Z0-9]{10}]/;
        return title.replace(regex, '');
    };
    ConversationsListComponent.prototype.prepareImages = function (message) {
        var images = message.images.map(function (img) {
            return {
                small: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName,
                medium: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName,
                big: environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName
            };
        });
        return images;
    };
    ConversationsListComponent.prototype.sendConversationMessage = function (messageComponent, conversationId) {
        var _this = this;
        var messageParams = messageComponent.prepareMessageParams();
        messageComponent.submitStart();
        this._conversationService.sendMessageToExistingConversation(this._mainService.userService.getUserId(), messageParams.content, messageComponent.currentConversation.conversationId, messageParams.images).then(function (result) {
            _this._conversationService.getConversation(conversationId).then(function (conversation) {
                messageComponent.submitFinished();
                var thanksInfo = _this._mainService.showInformation("Your message has been sent");
                setTimeout(function () {
                    thanksInfo.dismiss();
                    var conversationIndex = _this.conversations.findIndex(function (c) { return c.conversationId == conversationId; });
                    if (conversationIndex > -1) {
                        var img_1 = {};
                        conversation.messages.forEach(function (message, messageIndex) {
                            if (message.images.length > 0) {
                                img_1[message.conversationMessageId] = _this.prepareImages(message);
                            }
                        });
                        _this.images[conversationId] = img_1;
                        _this.conversations[conversationIndex].messages = conversation.messages;
                    }
                }, 2000);
                messageComponent.clear();
            });
        }).catch(function (err) {
            _this._mainService.showError(err);
            messageComponent.submitFinished();
        });
    };
    ConversationsListComponent.prototype.showDemoAdInfo = function (conversation) {
        return conversation.demoAdvertisement && this._currentUserIsAdmin;
    };
    ConversationsListComponent.prototype.resolveConversationSenderNick = function (conversation) {
        if (conversation.senderId == this.userNick) {
            return "You";
        }
        else
            return conversation.senderNick;
    };
    ConversationsListComponent.prototype.resolveMessageSenderNick = function (conversation, message) {
        if (message.senderId == this._mainService.userService.getUserId()) {
            return "You";
        }
        else {
            if (conversation.senderId == message.senderId) {
                return conversation.senderNick;
            }
            else
                return conversation.receiverNick;
        }
    };
    ConversationsListComponent.prototype.hasNewMessages = function (conversation) {
        var userId = this._mainService.userService.getUserId();
        return conversation.messages.filter(function (m) { return !m.isRead && m.senderId != userId; }).length > 0;
    };
    ConversationsListComponent.prototype.setUrlId = function (id) {
        this.activeConversationId = id;
        var newUrl = "conversations/" + id;
        window.history.pushState({ pageTitle: "conversations" }, "", newUrl);
    };
    ConversationsListComponent.prototype.setReadedMessages = function (conversation) {
        this._conversationService.setReadedMessages(conversation.conversationId, conversation.messages.map(function (c) { return c.conversationMessageId; })).then(function (r) {
            if (r) {
                conversation.hasNewMessages = false;
            }
        });
    };
    Object.defineProperty(ConversationsListComponent.prototype, "selectedConvCount", {
        get: function () {
            var _this = this;
            //this._selectedConvCount = document.getElementsByClassName("isSelected").length;
            this._selectedConvCount = 0;
            this.checboxListArray.forEach(function (e) {
                if (e['checked'] == true) {
                    _this._selectedConvCount++;
                }
            });
            return this._selectedConvCount;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsListComponent.prototype.deleteConversation = function (conversationId, arrayIndex) {
        var _this = this;
        this._mainService.showConfirm("Are you sure?", "300px").then(function (res) {
            if (res == confirmation_sheet_component_1.ConfirmationResult.Yes) {
                var thisConvElement_1 = document.getElementsByClassName('conversation-' + conversationId)[0];
                thisConvElement_1.classList.add("deleting");
                _this._conversationService.deleteConversation(conversationId, arrayIndex).then(function (res) {
                    _this._mainService.showInformation("Conversation deleted");
                    thisConvElement_1.remove();
                }).catch(function (err) {
                    _this._mainService.showError(err);
                });
            }
        });
    };
    ConversationsListComponent.prototype.selectAllConversations = function (e) {
        if (e.checked) {
            this.convListArray.forEach(function (e) {
                e.nativeElement.classList.add('isSelected');
                e.nativeElement.classList.add('showChecbox');
            });
            this.checboxListArray.forEach(function (e) {
                e['checked'] = true;
            });
        }
        else {
            this.convListArray.forEach(function (e) {
                e.nativeElement.classList.remove('isSelected');
            });
            this.checboxListArray.forEach(function (e) {
                e['checked'] = false;
            });
        }
    };
    ConversationsListComponent.prototype.selectConversation = function (e, i) {
        var convClassList = this.convListArray[i].nativeElement.classList;
        if (e.checked) {
        }
        else {
        }
        convClassList.toggle('isSelected');
        if (this.selectedConvCount == this.convListArray.length) {
            this.selectAllCheckbox = true;
        }
        else {
            this.selectAllCheckbox = false;
        }
    };
    ConversationsListComponent.prototype.deleteSelectedConv = function () {
        var _this = this;
        this._mainService.showConfirm("Are you sure to delete " + this.selectedConvCount + " conversations ?", "300px").then(function (res) {
            if (res == confirmation_sheet_component_1.ConfirmationResult.Yes) {
                _this.loading = true;
                var tmpDeletedCount_1 = 0;
                _this.checboxListArray.forEach(function (e) {
                    if (e['checked']) {
                        _this._conversationService.deleteConversation(parseInt(e.id)).then(function (res) {
                            tmpDeletedCount_1++;
                            if (_this.selectedConvCount == tmpDeletedCount_1) {
                                _this._mainService.showInformation("Conversations deleted");
                                _this.reloadConversations();
                            }
                        }).catch(function (err) {
                            _this._mainService.showError(err);
                        });
                    }
                });
            }
        });
    };
    ConversationsListComponent.prototype.restoreConvMsgs = function () {
        this._conversationService.restoreConversationsHasMessages();
    };
    return ConversationsListComponent;
}());
exports.ConversationsListComponent = ConversationsListComponent;
